export default __webpack_public_path__ + "static/media/banner.3dfd2461.png";